// extracted by mini-css-extract-plugin
module.exports = {"mail_delivered":"mailStatusCounter_mail_delivered__TX_69","mail_failed":"mailStatusCounter_mail_failed__3IBuo"};